// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nH5[data-v-944ff49a] {\r\n    margin-bottom: 8px;\n}\nP[data-v-944ff49a] {\r\n    margin-bottom: 8px;\n}\n.project DIV.q-card__section[data-v-944ff49a] {\r\n    padding: 8px;\n}\nDIV.text-h5[data-v-944ff49a] {\r\n    display: inline-block;\n}\nSPAN.date[data-v-944ff49a] {\r\n    display: inline-block;\r\n    font-style: italic;\r\n    padding-left: 8px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
